<!-- This example requires Tailwind CSS v2.0+ -->
<template>
    <div class="grid grid-cols-2 gap-4 p-5 bg-gray-800">
        <div>
            <h2 class="flex justify-start justify-items-center p-3 text-gray-200 text-lg font-semibold">Promocje</h2>
        </div>

        <div class="flex justify-end justify-items-center p-3">

            <Listbox as="div" v-model="selected">
                <ListboxLabel class="sr-only">Change department</ListboxLabel>
                <div class="relative">
                    <div class="inline-flex shadow-sm rounded-md divide-x divide-gray-600">
                        <div class="relative z-0 inline-flex shadow-sm rounded-md divide-x divide-gray-600">
                            <div
                                class="relative inline-flex items-center bg-gray-500 py-2 pl-3 pr-4 border border-transparent rounded-l-md shadow-sm text-white">
                                <CheckIcon class="h-5 w-5" aria-hidden="true"/>
                                <p class="ml-2.5 text-xs font-medium">{{ selected.title }}</p>
                            </div>
                            <ListboxButton
                                class="relative inline-flex items-center bg-gray-500 p-2 rounded-l-none rounded-r-md text-sm font-medium text-white hover:bg-gray-600 focus:outline-none focus:z-10 focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-gray-500">
                                <span class="sr-only">Change department</span>
                                <ChevronDownIcon class="h-5 w-5 text-white" aria-hidden="true"/>
                            </ListboxButton>
                        </div>
                    </div>

                    <transition leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100"
                                leave-to-class="opacity-0">
                        <ListboxOptions
                            class="origin-top-right absolute z-10 right-0 mt-2 w-72 rounded-md shadow-lg overflow-hidden bg-white divide-y divide-gray-200 ring-1 ring-black ring-opacity-5 focus:outline-none">
                            <ListboxOption as="template" v-for="option in publishingOptions" :key="option.title"
                                           :value="option" v-slot="{ active, selected }">
                                <li :class="[active ? 'text-white bg-gray-500' : 'text-gray-900', 'cursor-default select-none relative p-4 text-sm']">
                                    <div class="flex flex-col">
                                        <div class="flex justify-between">
                                            <p :class="selected ? 'font-semibold' : 'font-normal'">
                                                {{ option.title }}
                                            </p>
                                            <span v-if="selected" :class="active ? 'text-white' : 'text-gray-500'">
                    <CheckIcon class="h-5 w-5" aria-hidden="true"/>
                  </span>
                                        </div>
                                        <p :class="[active ? 'text-gray-200' : 'text-gray-500', 'mt-2']">
                                            {{ option.description }}
                                        </p>
                                    </div>
                                </li>
                            </ListboxOption>
                        </ListboxOptions>
                    </transition>
                </div>
            </Listbox>
        </div>
    </div>
</template>

<script>
import {ref} from 'vue'
import {Listbox, ListboxButton, ListboxLabel, ListboxOption, ListboxOptions} from '@headlessui/vue'
import {CheckIcon, ChevronDownIcon} from '@heroicons/vue/solid'

const publishingOptions = [
    {id: 1, title: 'Supermarket "u Chowańca"', description: 'ul. Cieszyńska 394', current: true},
    {id: 2, title: 'Market "u Chowańca"', description: 'ul. Wapienicka 1', current: false},
    {id: 3, title: 'Rzeźnik "u Chowańca"', description: 'ul. Cieszyńska 394', current: false},
    {id: 4, title: 'Domoteo', description: 'ul. Cieszyńska 394', current: false},
    {id: 4, title: 'Petit', description: 'ul. Cieszyńska 396', current: false},
]

export default {
    name: "SelectDepartment",
    components: {
        Listbox,
        ListboxButton,
        ListboxLabel,
        ListboxOption,
        ListboxOptions,
        CheckIcon,
        ChevronDownIcon,
    },
    setup() {
        const selected = ref(publishingOptions[0])

        return {
            publishingOptions,
            selected,
        }
    },
    watch: {
        selected(newSelection, oldSelection) {
            this.$emit('departmentChange', newSelection.id);
        }
    }
}
</script>
